function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/*********************************************************************************
 GAME WEB3


**********************************************************************************/
var GameWeb3 = /*#__PURE__*/function () {
  function GameWeb3() {
    _classCallCheck(this, GameWeb3);
  }
  return _createClass(GameWeb3, [{
    key: "initializeGameStake",
    value:
    //
    // games can override this function if they want to support crypto integration and
    // have any module-specific initialization work to do. it is a good idea to restart
    // the game for instance...
    //
    function () {
      var _initializeGameStake = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(ticker, stake) {
        var obj, cm, cmenu;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.game.options.crypto = ticker;
              this.game.options.stake = stake;
              this.game.crypto = ticker;
              this.game.stake = stake;

              // Need to parse if asymmetrical
              if (_typeof(stake) === 'object') {
                obj = Object.assign({}, stake);
                delete obj.min;
                stake = Object.values(obj).join(' / ');
              }
              this.updateLog("Crypto Activated: ".concat(stake, " ").concat(ticker));
              siteMessage("Crypto Activated: ".concat(stake, " ").concat(ticker), 2000);
              this.saveGame(this.game.id);
              if (this.gameBrowserActive()) {
                this.insertCryptoLogo(ticker);

                // Updates playerboxes (if used)
                this.insertLeagueRankings();

                // Re-render game-menu
                cm = this.app.modules.returnModule('Crypto');
                if (cm) {
                  cmenu = cm.respondTo('game-menu', this);
                  this.menu.replaceMenuByID(cmenu);
                }
              }
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initializeGameStake(_x, _x2) {
        return _initializeGameStake.apply(this, arguments);
      }
      return initializeGameStake;
    }()
  }, {
    key: "insertCryptoLogo",
    value: function insertCryptoLogo(ticker) {
      var results = this.app.modules.getRespondTos('crypto-logo', {
        ticker: ticker
      });
      if (results.length > 0) {
        var _results$, _results$2, _results$3;
        var html = "<div class=\"game-crypto-logo-container\">";
        if ((_results$ = results[0]) !== null && _results$ !== void 0 && _results$.svg) {
          html += results[0].svg;
        } else if ((_results$2 = results[0]) !== null && _results$2 !== void 0 && _results$2.alt_img) {
          html += "<img class=\"crypto-logo\" src=\"".concat(results[0].alt_img, "\">");
        } else if ((_results$3 = results[0]) !== null && _results$3 !== void 0 && _results$3.img) {
          html += "<img class=\"crypto-logo\" src=\"".concat(results[0].img, "\">");
        } else {
          return;
        }
        html += '</div>';
        if (document.querySelector('.crypto_logo')) {
          return;
        }
        if (document.querySelector('.main')) {
          this.app.browser.prependElementToSelector(html, '.main');
        } else if (this.getBoardElement && this.getBoardElement()) {
          this.app.browser.prependElementToDom(html, this.getBoardElement());
        } else {
          this.app.browser.prependElementToSelector(html, 'body');
        }
      }
    }

    //
    // this allows players to propose a crypto/web3 stake for the game. it will trigger
    // the STAKE command among players who have not INIT'd or APPROVED the shift allowing
    // them to accept / reject the idea.
    //
  }, {
    key: "proposeGameStake",
    value: function () {
      var _proposeGameStake = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var ticker,
          stake,
          sigs,
          ts,
          privateKey,
          stake_val,
          _args2 = arguments;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              ticker = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : '';
              stake = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : '';
              sigs = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : [];
              ts = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : new Date().getTime();
              //
              // use sigs to track the confirmations
              //

              while (sigs.length < this.game.players.length) {
                sigs.push('');
              }
              _context2.n = 1;
              return this.app.wallet.getPrivateKey();
            case 1:
              privateKey = _context2.v;
              stake_val = _typeof(stake) === 'object' ? stake === null || stake === void 0 ? void 0 : stake.min : stake;
              sigs[this.game.player - 1] = this.app.crypto.signMessage("".concat(ts, " ").concat(ticker, " ").concat(stake_val, " ").concat(this.game.id), privateKey);
              this.sendMetaMessage('STAKE', {
                ticker: ticker,
                stake: stake,
                sigs: sigs,
                ts: ts
              });
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function proposeGameStake() {
        return _proposeGameStake.apply(this, arguments);
      }
      return proposeGameStake;
    }()
  }, {
    key: "refuseGameStake",
    value: function () {
      var _refuseGameStake = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var ticker,
          stake,
          _args3 = arguments;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              ticker = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : '';
              stake = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : '';
            case 1:
              return _context3.a(2);
          }
        }, _callee3);
      }));
      function refuseGameStake() {
        return _refuseGameStake.apply(this, arguments);
      }
      return refuseGameStake;
    }()
    /**
     * Called by the SETTLE queue command when the game has ended.
     * Adds standard SEND/RECEIVE payment commands to the queue for each
     * loser's obligation to the winner(s).
     *
     * Table games override this to settle accumulated per-hand debt instead.
     */
  }, {
    key: "queueGameStakeSettlement",
    value: function queueGameStakeSettlement() {
      var _this$game, _this$game2;
      var winners = this.game.winner;
      console.info('GT [queueGameStakeSettlement] winners: ', winners);
      if (!((_this$game = this.game) !== null && _this$game !== void 0 && _this$game.stake) || !((_this$game2 = this.game) !== null && _this$game2 !== void 0 && _this$game2.crypto)) {
        console.debug('GT [queueGameStakeSettlement] No stake: ', this.game.stake, this.game.crypto);
        return;
      }
      if (this.game.crypto == 'CHIPS') {
        console.debug('GT [queueGameStakeSettlement] Playing with chips: ', this.game.stake, this.game.crypto);
        return;
      }
      var amount_to_send;
      for (var i = 0; i < this.game.players.length; i++) {
        if (_typeof(this.game.stake) == 'object') {
          amount_to_send = this.game.stake[this.game.players[i]];
        } else {
          amount_to_send = parseFloat(this.game.stake);
        }
        var loser = this.game.players[i];
        if (Array.isArray(winners)) {
          if (winners.length === 0) {
            continue;
          }
          amount_to_send = amount_to_send / winners.length;
          if (!winners.includes(loser)) {
            var _iterator = _createForOfIteratorHelper(winners),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var winner = _step.value;
                this.addPaymentToQueue(loser, winner, amount_to_send);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
        } else {
          if (winners && loser !== winners) {
            this.addPaymentToQueue(loser, winners, amount_to_send);
          }
        }
      }
    }
  }, {
    key: "addPaymentToQueue",
    value: function addPaymentToQueue(sender, receiver, amount_to_send) {
      if (!(parseFloat(amount_to_send) > 0)) {
        return;
      }
      var ts = new Date().getTime();
      this.rollDice();
      amount_to_send = this.app.crypto.convertFloatToSmartPrecision(parseFloat(amount_to_send));
      var amount_for_unique_hash = amount_to_send;
      if (this.game.crypto == 'SAITO') {
        amount_for_unique_hash = this.app.wallet.convertSaitoToNolan(amount_for_unique_hash).toString();
      }
      var uh = this.app.crypto.hash(Buffer.from(sender + receiver + amount_for_unique_hash + this.game.dice + this.game.crypto, 'utf-8'));
      console.debug("GT [addPaymentToQueue]: ".concat(sender, "\t").concat(receiver, "\t").concat(amount_to_send, "\t").concat(this.game.crypto));
      this.game.queue.push("RECEIVE\t".concat(sender, "\t").concat(receiver, "\t").concat(amount_to_send, "\t").concat(ts, "\t").concat(uh, "\t").concat(this.game.crypto));
      this.game.queue.push("SEND\t".concat(sender, "\t").concat(receiver, "\t").concat(amount_to_send, "\t").concat(ts, "\t").concat(uh, "\t").concat(this.game.crypto));
    }

    //
    // float to string
    //
  }, {
    key: "fts",
    value: function fts(val) {
      try {
        if (val.toFixed(8)) {
          val = val.toFixed(8);
        }
      } catch (err) {}
      return this.app.crypto.convertStringToDecimalPrecision(val);
    }

    //
    // string to float
    //
  }, {
    key: "stf",
    value: function stf(val) {
      if (!isNaN(val) && val.toString().indexOf('.') != -1) {
        return parseFloat(parseFloat(val).toFixed(8));
      }
      val = parseFloat(val);
      val = parseFloat(val.toFixed(8));
      return val;
    }

    //
    // add to string
    //
  }, {
    key: "addToString",
    value: function addToString(x, add_me) {
      var y = this.stf(x) + this.stf(add_me);
      y = this.fts(y);
      return this.app.crypto.convertStringToDecimalPrecision(y, 8);
    }

    //
    // subtract from string
    //
  }, {
    key: "subtractFromString",
    value: function subtractFromString(x, subtract_me) {
      var y = this.stf(x) - this.stf(subtract_me);
      if (y < 0) {
        y = 0;
      }
      return this.app.crypto.convertStringToDecimalPrecision(y, 8);
    }
  }, {
    key: "showStakeOverlay",
    value: function showStakeOverlay() {
      var html = "<div class=\"stake-info-overlay\"><div class=\"h3\">Game Stake</div>";
      if (_typeof(this.game.stake) === 'object') {
        html += "<div class=\"player-table\">";
        for (var i in this.game.stake) {
          if (i !== 'min') {
            html += "<div>".concat(this.app.keychain.returnUsername(i), "</div> <div>stakes</div> <div>").concat(this.game.stake[i], " ").concat(this.game.crypto, "</div>");
          }
        }
        html += '</div>';
      } else {
        html += "<div class=\"player-bet-info\">".concat(this.game.stake, " ").concat(this.game.crypto, " staked on this game!</div>");
      }
      html += '</div>';
      this.overlay.show(html);
    }
  }]);
}();
module.exports = GameWeb3;